(() => {
  if (window.cvVariantFastBound) return;
  window.cvVariantFastBound = true;
  document.documentElement.dataset.cvVariantFast = 'ready';

  const getInput = (target) => {
    if (!(target instanceof Element)) return null;
    if (target.matches('input[data-option-name]')) return target;
    return target.closest('label')?.querySelector('input[data-option-name]') || null;
  };

  const getPreview = (input) => {
    const optionName = input.dataset.optionName?.toLowerCase();
    if (optionName !== 'color' && optionName !== 'colour') return null;

    const picker = input.closest('variant-picker');
    if (!picker || picker.closest('product-card, quick-add-dialog')) return null;

    const product = picker.closest('.product-information') || picker.closest('.shopify-section');
    const data = product?.querySelector('[data-cv-variant-previews]');
    if (!data) return null;

    try {
      const position = Number.parseInt(input.dataset.inputId?.split('-')[0] || '1', 10) - 1;
      const variants = JSON.parse(data.textContent || '[]');
      const variant = variants.find((item) => item.options?.[position] === input.value);
      return variant?.imageUrl ? { product, variant } : null;
    } catch (error) {
      console.warn('[cv-variant] Invalid preview data', error);
      return null;
    }
  };

  const preload = (event) => {
    const input = getInput(event.target);
    if (!input) return;
    const preview = getPreview(input);
    if (!preview) return;
    const image = new Image();
    image.src = preview.variant.imageUrl;
  };

  document.addEventListener('pointerover', preload, true);
  document.addEventListener('focusin', preload, true);

  const showPreview = (event) => {
    const input = getInput(event.target);
    if (!input) return;
    const preview = getPreview(input);
    if (!preview) return;

    const gallery = preview.product?.querySelector('media-gallery');
    const image = gallery?.querySelector('.product-media__image');
    if (!image) return;

    image.removeAttribute('srcset');
    image.src = preview.variant.imageUrl;
    image.alt = preview.variant.imageAlt || image.alt;
    image.dataset.maxResolution = preview.variant.imageUrl;
  };

  document.addEventListener('pointerdown', showPreview, true);
  document.addEventListener('click', showPreview, true);
  document.addEventListener('change', showPreview, true);
})();
